export const setupFooter = () => {
  const footerTitleToggles = document.querySelectorAll('.footer-nav__title--toggle');

  footerTitleToggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const footerContent = toggle.nextElementSibling as HTMLElement;
      toggle.classList.toggle('active');
      footerContent?.classList.toggle('active');
    });
  });
};
